import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetGeneralModal, selectGeneralModal } from "slices/generalSlice";
import Modal from "../../HOCS/Modal";

const GeneralModal = () => {
  const dispatch = useDispatch();
  const generalModal = useSelector(selectGeneralModal);

  if (generalModal) {
    return (
      <Modal
        growth={false}
        noBackDropClick={generalModal.noBackDropClick}
        lightBackDrop={false}
        header={generalModal.title}
        content={generalModal.content}
        onDismiss={() => {
          dispatch(resetGeneralModal());
        }}
      />
    );
  } else {
    return null;
  }
};

export default GeneralModal;
